export default {
  metadata: {
    version: '1.0.0',
    name: 'JDSAvatarV2Status'
  },
  hierarchy: {
    container: [
      'jds_avatar_v2_default',
      {
        'badge-container': ['jds_badge_v2']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      opacity: '{opacity.enabled}',
      hidden: false
    },
    jds_avatar_v2_default: {
      size: 'medium'
    },
    'badge-container': {
      'padding-top': '{custom_11}',
      'padding-left': '{custom_11}',
      'padding-bottom': '{custom_5}',
      'z-index': 1,
      disabled: true
    },
    jds_badge_v2: {
      kind: 'status',
      statusKind: 'dot',
      size: 'medium'
    }
  },
  variant: {
    kind: {
      icon: {
        jds_badge_v2: {
          statusKind: 'icon',
          size: 'medium'
        },
        'badge-container': {
          'padding-top': '{custom_11}',
          'padding-left': '{custom_11}',
          'padding-bottom': '{custom_5}'
        }
      },
      text: {
        jds_badge_v2: {
          statusKind: 'label-container',
          size: 'xtra-small'
        },
        'badge-container': {
          'padding-top': '{l}',
          'padding-left': '{base}',
          'padding-bottom': '{custom_5}'
        }
      }
    },
    size: {
      'xtra-xtra-large': {
        jds_avatar_v2_default: {
          size: 'xtra-xtra-large'
        },
        'badge-container': {
          'padding-top': '{custom_7}',
          'padding-left': '{custom_7}',
          'padding-bottom': '{custom_5}'
        },
        jds_badge_v2: {
          size: 'xtra-xtra-large'
        }
      },
      'xtra-large': {
        jds_avatar_v2_default: {
          size: 'xtra-large'
        },
        jds_badge_v2: {
          size: 'large'
        },
        'badge-container': {
          'padding-top': '{custom_10}',
          'padding-left': '{custom_10}',
          'padding-bottom': '{custom_5}'
        }
      },
      large: {
        jds_avatar_v2_default: {
          size: 'large'
        },
        jds_badge_v2: {
          size: 'medium'
        },
        'badge-container': {
          'padding-top': '{l}',
          'padding-left': '{l}',
          'padding-bottom': '{custom_5}'
        }
      },
      small: {
        jds_avatar_v2_default: {
          size: 'small'
        },
        jds_badge_v2: {
          size: 'small'
        },
        'badge-container': {
          'padding-top': '{custom_13}',
          'padding-left': '{custom_13}',
          'padding-bottom': '{custom_5}'
        }
      },
      'xtra-small': {
        jds_avatar_v2_default: {
          size: 'xtra-small'
        },
        'badge-container': {
          'padding-top': '{base}',
          'padding-left': '{base}',
          'padding-bottom': '{custom_5}'
        },
        jds_badge_v2: {
          size: 'xtra-small'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{opacity.disabled}'
        }
      }
    }
  },
  combination: [
    {
      icon: {
        'xtra-xtra-large': {
          bottom: {
            jds_badge_v2: {
              size: 'xtra-xtra-large'
            },
            'badge-container': {
              'padding-top': '{custom_7}',
              'padding-left': '{custom_7}'
            }
          },
          top: {
            jds_badge_v2: {
              size: 'xtra-xtra-large'
            },
            'badge-container': {
              'padding-bottom': '{custom_7}',
              'padding-left': '{custom_7}',
              'padding-top': '{custom_5}'
            }
          }
        },
        'xtra-large': {
          bottom: {
            jds_badge_v2: {
              size: 'large'
            },
            'badge-container': {
              'padding-top': '{custom_10}',
              'padding-left': '{custom_10}'
            }
          },
          top: {
            jds_badge_v2: {
              size: 'large'
            },
            'badge-container': {
              'padding-bottom': '{custom_10}',
              'padding-left': '{custom_10}',
              'padding-top': '{custom_5}'
            }
          }
        },
        large: {
          bottom: {
            jds_badge_v2: {
              size: 'medium'
            },
            'badge-container': {
              'padding-top': '{l}',
              'padding-left': '{l}'
            }
          },
          top: {
            jds_badge_v2: {
              size: 'medium'
            },
            'badge-container': {
              'padding-bottom': '{l}',
              'padding-left': '{l}',
              'padding-top': '{custom_5}'
            }
          }
        },
        medium: {
          top: {
            jds_badge_v2: {
              size: 'medium'
            },
            'badge-container': {
              'padding-bottom': '{custom_11}',
              'padding-left': '{custom_11}',
              'padding-top': '{custom_5}'
            }
          }
        },
        small: {
          bottom: {
            jds_badge_v2: {
              size: 'small'
            },
            'badge-container': {
              'padding-top': '{custom_13}',
              'padding-left': '{custom_13}'
            }
          },
          top: {
            jds_badge_v2: {
              size: 'small'
            },
            'badge-container': {
              'padding-bottom': '{custom_13}',
              'padding-left': '{custom_13}',
              'padding-top': '{custom_5}'
            }
          }
        },
        'xtra-small': {
          bottom: {
            jds_badge_v2: {
              size: 'xtra-small'
            },
            'badge-container': {
              'padding-top': '{base}',
              'padding-left': '{base}'
            }
          },
          top: {
            jds_badge_v2: {
              size: 'xtra-small'
            },
            'badge-container': {
              'padding-bottom': '{base}',
              'padding-left': '{base}',
              'padding-top': '{custom_5}'
            }
          }
        }
      },
      dot: {
        'xtra-xtra-large': {
          top: {
            'badge-container': {
              'padding-bottom': '{custom_7}',
              'padding-left': '{custom_7}',
              'padding-top': '{custom_5}'
            },
            jds_badge_v2: {
              size: 'xtra-xtra-large'
            }
          }
        },
        'xtra-large': {
          top: {
            jds_badge_v2: {
              size: 'large'
            },
            'badge-container': {
              'padding-bottom': '{custom_10}',
              'padding-left': '{custom_10}',
              'padding-top': '{custom_5}'
            }
          }
        },
        large: {
          top: {
            jds_badge_v2: {
              size: 'medium'
            },
            'badge-container': {
              'padding-bottom': '{l}',
              'padding-left': '{l}',
              'padding-top': '{custom_5}'
            }
          }
        },
        medium: {
          top: {
            jds_badge_v2: {
              size: 'medium'
            },
            'badge-container': {
              'padding-bottom': '{l}',
              'padding-left': '{custom_11}',
              'padding-top': '{custom_5}'
            }
          }
        },
        small: {
          top: {
            jds_badge_v2: {
              size: 'small'
            },
            'badge-container': {
              'padding-bottom': '{custom_13}',
              'padding-left': '{custom_13}',
              'padding-top': '{custom_5}'
            }
          }
        },
        'xtra-small': {
          top: {
            'badge-container': {
              'padding-bottom': '{base}',
              'padding-left': '{base}',
              'padding-top': '{custom_5}'
            },
            jds_badge_v2: {
              size: 'xtra-small'
            }
          }
        }
      },
      text: {
        'xtra-xtra-large': {
          bottom: {
            jds_badge_v2: {
              size: 'medium'
            },
            'badge-container': {
              'padding-top': '{custom_7}',
              'padding-left': '{huge}'
            }
          },
          top: {
            jds_badge_v2: {
              size: 'medium'
            },
            'badge-container': {
              'padding-bottom': '{custom_7}',
              'padding-left': '{huge}',
              'padding-top': '{custom_5}'
            }
          }
        },
        'xtra-large': {
          bottom: {
            jds_badge_v2: {
              size: 'xtra-small'
            },
            'badge-container': {
              'padding-top': '{xl}',
              'padding-left': '{custom_12}'
            }
          },
          top: {
            jds_badge_v2: {
              size: 'xtra-small'
            },
            'badge-container': {
              'padding-bottom': '{custom_8}',
              'padding-left': '{custom_12}',
              'padding-top': '{custom_5}'
            }
          }
        },
        large: {
          bottom: {
            jds_badge_v2: {
              size: 'xtra-small'
            },
            'badge-container': {
              'padding-top': '{custom_10}',
              'padding-left': '{m}'
            }
          },
          top: {
            jds_badge_v2: {
              size: 'xtra-small'
            },
            'badge-container': {
              'padding-bottom': '{custom_20}',
              'padding-left': '{m}',
              'padding-top': '{custom_5}'
            }
          }
        },
        medium: {
          top: {
            jds_badge_v2: {
              size: 'xtra-small'
            },
            'badge-container': {
              'padding-bottom': '{custom_8}',
              'padding-left': '{base}',
              'padding-top': '{custom_5}'
            }
          }
        },
        small: {
          bottom: {
            container: {
              hidden: true
            }
          },
          top: {
            container: {
              hidden: true
            }
          }
        },
        'xtra-small': {
          bottom: {
            container: {
              hidden: true
            }
          },
          top: {
            container: {
              hidden: true
            }
          }
        }
      }
    }
  ],
  combination_config: [['kind', 'size', 'placement']],
  api: {
    config: {
      kind: {
        values: ['dot', 'icon', 'text']
      },
      size: {
        values: [
          'medium',
          'xtra-xtra-large',
          'xtra-large',
          'large',
          'small',
          'xtra-small'
        ]
      },
      placement: {
        values: ['bottom', 'top']
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      jds_avatar_v2_default: {
        image: {
          type: 'image',
          name: 'avatarImage'
        },
        initials: {
          type: 'string',
          name: 'avatarInitials'
        },
        kind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        }
      },
      jds_badge_v2: {
        label: {
          type: 'string',
          name: 'label'
        },
        border: {
          type: 'boolean',
          name: 'badgeBorder'
        },
        status: {
          type: 'JDSBadgeV2Status.status',
          name: 'badgeStatus'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            value: 'Avatar with Status Badge'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
